const source = 'podsDataTable'

function DialogVoltura () {

  const keys = Object.keys(this.filtered.items).filter((s) => s == source)
  if(keys.length > 0){
    const ids = this.filtered.items[source];

    const id = Array.isArray(ids) 
    ? ids[0]?.id || ids[0]?.["<target>"]?.id || null
    : null;

console.log(id);
    this.$eventBus.emit('show-dialog-page', {
      page: 'DialogVoltura',
      title: 'Voltura',
      data: { id: ids[0].id },
      maximize: false,
      buttonOk: {
        label: 'Esegui',
        icon: 'pi pi-check',
        class: '',
        visible: true,
        disabled: false,
      },

      buttonCancel: {
        label: 'Annulla',
        icon: 'pi pi-times',
        class: 'p-button-text',
        visible: true,
        disabled: false,
      },
    })
  } 
}

export default {
  'bindTo': 'this',
  'method': DialogVoltura,
}
